export default "__VITE_ASSET__Cae53d4U__"